<div class="trinka_cloud_wrap">

    <div class="trinka_cloud_wrap1">
        <div class="cloud_top_banners">
            <div class="container">
                <div class="row">
                    <div class="col-lg-7">
                        <div class="trinka_cloud_banner_text">
                            <h1>引文检查器</h1>
                            <h2>加强你的研究论证</h2>
                            <p>Trinka引文检查器进行自动引文分析，以识别可能削弱您的研究前提和论证的引文，并帮助您为您的论文引用可信的、权威的引文。</p>
                            <a href="https://cloud.trinka.ai/signup?_rg=CN" id="autoEditGetStart" target="_blank">立刻查看</a>
                        </div>
                    </div>
                    <div class="col-lg-5">
                        <div class="trinka_cloud_banner_img text-center" style="text-align: center !important;">
                            <img src="assets/images/Reference-Quality-Check.png" alt="Citation Checker">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="how_it_work_section" style="display: none;">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="how_it_work_content">
                        <div class="howItWorkHeading">
                            <h2>How It Works</h2>
                            <div class="HeadingSubLine"></div>
                        </div>
                        <ul>
                            <li>
                                <div class="login_circle_section">
                                    <img src="assets/images/RegisterAndLogin.png" alt="">
                                </div>
                                <h3>Register / Login</h3>
                            </li>
                            <li>
                                <div class="login_circle_section">
                                    <img src="assets/images/TypeOrImportFile_icon.png" alt="">
                                </div>
                                <h3>Select auto file edit <br />& upload your file</h3>
                            </li>
                            <li>
                                <div class="login_circle_section">
                                    <img src="assets/images/improveYourWriting_icon.png" alt="">
                                </div>
                                <h3>Download file with<br /> track changes </h3>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <div class="SectionHowItWrok">
        <div class="container">
            <div class="row">
                <div class="col-xl-6">
                    <div class="ImgSectionHowItWrok">
                        <a href="" data-toggle="modal" data-target="#wordPluginPopup" id="VewiVideoSection">
                            <img src=".././../../assets/images/citation-video.png" alt="" class="img-fluid eposter-img">
                        </a>
                    </div>
                </div>
                <div class="col-xl-6">
                    <div class="contentSectionHowItWrok">
                        <h2>查看它是如何运作的</h2>
                        <div class="HeadingSubLine"></div>
                        <p style="margin-bottom: 10px;">请看Trinka引文检查器是如何工作的，起动快速。</p>
                        <p style="margin-bottom: 10px;">简单的操作视频将帮助您最有效地利用这一功能。</p>
                        <p>更多问题？请在<a style="color: #0000ff;" (click)="scroll(target)" class="link">这里</a>浏览我们的常见问题。</p>
                    </div>
                </div>
                
            </div>
        </div>
    </div>

    <div class="cloud_key_features">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="key_features_heading">
                        <h2>Trinka引文检查器的主要特点</h2>
                        <div class="HeadingSubLine"></div>
                        <p>Trinka引文检查器可以识别各种质量风险，进行有力的引文分析，让您改进参考文献列表，加强研究论证。</p>
                    </div>
                </div>
            </div>
            <div class="row match-box">

                <div class="col-lg-4 col-md-6 dflex">
                    <div class="features_cards c-card">
                        <img src="assets/images/Retracted-References.png" alt="">
                        <h3>被撤稿的引文</h3>
                        <p>识别出版后被撤稿的论文，避免同行评审者的批评。</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6 dflex">
                    <div class="features_cards c-card">
                        <img src="assets/images/Non-standard-References.png" alt="">
                        <h3>非标准引文</h3>
                        <p>排除未经同行评审的研究来提高您引文可信度。</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 dflex">
                    <div class="features_cards c-card">
                        <img src="assets/images/low-visibility.png" alt="">
                        <h3>低能见度引文</h3>
                        <p>找出未被其他作者频繁引用的引文，避免削弱您论证力度。</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 dflex">
                    <div class="features_cards c-card">
                        <img src="assets/images/Old-References.png" alt="">
                        <h3>旧参考资料</h3>
                        <p>轻松识别很久以前发表的论文，以确保您引文的高度相关性和有效性。</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6 dflex">
                    <div class="features_cards c-card">
                        <img src="assets/images/Overuse.png" alt="">
                        <h3>过度引用特定期刊</h3>
                        <p>识别对特定期刊的不经意的过度引用，以使您的引文来源多样化来避免同行评审的批评。</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="uploadOptionSection">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="key_features_heading">
                        <h2>为什么选择Trinka引文检查器</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                </div>
            </div>
            <div class="row match-box">
                <div class="col-sm-6 dflex">
                    <div class="c-card trinka-checker rchecker">
                        <div class="media">
                            <div class="media-left">
                                <img src="assets/images/languageScore_icon.svg" alt="Free Score Overview" />
                            </div>
                            <div class="media-body">
                                <h3>免费引文分数</h3>
                                <p>免费生成引文分析得分，让您视需要购买引文报告。</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 dflex">
                    <div class="c-card trinka-checker">
                        <div class="media">
                            <div class="media-left">
                                <img src="assets/images/Up-to-date-Repository.png" alt="Free Score Overview" />
                            </div>
                            <div class="media-body">
                                <h3>Crossref验证</h3>
                                <p>您的所有引文都会根据Crossref广泛的出版物资料库进行验证，该资料库受到全世界出版商和组织的信任。</p>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div class="cloud_key_features" style="padding: 0;margin: 0 0 60px 0;">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="key_features_heading">
                        <h2>查看报告样本</h2>
                        <div class="HeadingSubLine"></div>
                        <p>请见Trinka引文检查器的引文分析报告样本，了解您如何能从中改善您的论文</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-1"></div>
                <div class="col-sm-10">
                    <div class="viewSampleReportImg">
                        <a href="citation-checker/sample-report/">查看完整报告 <i class="fa fa-arrows-alt" aria-hidden="true"></i></a>
                        <img src="assets/images/citation-report.jpg" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div class="use_trinka_other_app accomplishBrilliantWrap">
        <div class="container">
            <div class="accomplishBrilliantSection">
                <h2>现在就获取您的免费引文分析得分</h2>
                <a href="https://cloud.trinka.ai/signup?_rg=CN" target="_blank">立刻开始</a>
            </div>
        </div>
    </div>

    <div class="allAboutTrinkaCredit">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="aboutTrinkaCreditHeading">
                        <h2>引文检查器使用积分</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                    <div class="creditSectionFeature">
                        
                        <div class="featurePointsCredits">
                            <span>
                                <img src="assets/images/credits_icon.png" alt="">
                            </span>
                            <p>引文分析分数是免费的；您仅为完整的报告付费。为了生成报告，1个积分最多可用于10条引文。使用免费分数或根据需要购买更多分数。
                            </p>
                        </div>
                        <div class="othersPointsForCredits">
                            <p style="margin-bottom: 0px;">积分类似于代币，可以让你根据需要使用Trinka的一些功能。</p>
                            <p>高级用户每月可获得10个免费点数，基本用户每月可获得4个免费点数。欲了解更多, <a [routerLink]="['/features/credits']">请点击这里</a>。</p>
                        </div>
                    </div>
                </div>
                
                <!-- <div class="col-lg-4 col-md-6">
                    <div class="CreditBoxTrinka">
                        <div class="card_overlay"></div>
                        <div class="CreditBoxTrinkaHeader">
                            <h3>Free Credits Available</h3>
                        </div>
                        <p>Basic users get 2 and Premium users get 5 free credits every month. Unused free credits expire at month end.</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="CreditBoxTrinka">
                        <div class="card_overlay"></div>
                        <div class="CreditBoxTrinkaHeader">
                            <h3>Credits Consumed</h3>
                        </div>
                        <p>Auto File Edit uses 1 credit for every 5000 words. You may upload larger files; credits required will be shown and consumed accordingly. </p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="CreditBoxTrinka">
                        <div class="card_overlay"></div>
                        <div class="CreditBoxTrinkaHeader">
                            <h3>Buy More Credits</h3>
                        </div>
                        <p>If you need additional credits, you can purchase them whenever needed. Purchased Credits do not expire.</p>
                    </div>
                </div> -->
            </div>
        </div>
    </div>

    <div class="pricingQuestionAnwser" #target>
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="pricingHeadingQuestion">
                        <h2>常见问题</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-1"></div>
                <div class="col-lg-10">
                    <div class="pricingQuestionsList">
                        <div class="accordion" id="faq">
                            <div class="card">
                                <div class="card-header" id="QuestionOne">
                                    <a href="#" class="btn btn-header-link" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                        Trinka引文检查器是如何工作的？</a>
                                </div>

                                <div id="QuestionOneContent" class="collapse show" aria-labelledby="QuestionOne" data-parent="#faq">
                                    <div class="card-body">
                                        <h4>通过3个简单的步骤提高您的引文质量!</h4>
                                        <ol>
                                            <li>仅需在Trinka上免费<a href="https://cloud.trinka.ai/signup" target="_blank">注册</a>。 </li>
                                            <li>从左边的导航面板转到引文检查器页面。</li>
                                            <li>上传你的文件。你可以从Google Drive、OneDrive、Dropbox或你的电脑上传。您也可以使用已经上传至Trinka的文件。您将在几分钟内获取您的报告!</li>
                                        </ol>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionTwo">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                        aria-controls="QuestionTwoContent">
                                        在哪里可以访问Trinka引文检查器？</a>
                                </div>

                                <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka引文检查器功能目前只在Trinka云平台上向所有用户提供。它很快也会出现在Word插件中。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionThree">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true"
                                        aria-controls="QuestionThreeContent">
                                        Trinka可否审阅对付费文章的引用？
                                    </a>
                                </div>

                                <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                                    <div class="card-body">
                                        <p>是的。我们可以对您的引文进行质量检查，即使这些引文是发表在付费期刊上。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionFour">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                        aria-controls="QuestionFourContent">
                                        我可以与我的合著者分享引文报告吗？
                                    </a>
                                </div>

                                <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                    <div class="card-body">
                                        <!-- <p>In addition to all the features you get in Basic, you also get Power Mode with a Premium subscription.  Power Mode provides users with up to 40% more suggestions for their content while considering the context of the writing. Furthermore, </p> -->
                                        <p>目前报告是不可分享的。我们将在未来实现这种情况! </p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="col-lg-1"></div>
            </div>
        </div>
    </div>


    <div class="use_trinka_other_app">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="use_trinka_content">
                        <div class="use_trinka_heading">
                            <div class="howItWorkHeading lineWhiteColor">
                                <h2>在其他应用程序中使用Trinka</h2>
                                <div class="HeadingSubLine"></div>
                            </div>
                        </div>
                        <div class="others_app_name">
                            <ul>
                                <li>
                                    <a [routerLink]="['/trinkacloud']">
                                        <div class="app_name_content">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="assets/images/Other_apps_TrinkaCloud.svg" alt="">
                                            <h3><span class="OpenSansFonts" style="font-weight: bold; font-size: 18px">Trinka</span>云</h3>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a [routerLink]="['/wordplugin']">
                                        <div class="app_name_content">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="assets/images/Others_App_MSWord.svg" alt="">
                                            <h3>
                                                <span class="OpenSansFonts" style="font-weight: bold;font-size: 18px;">Word</span>
                                                <br />插件</h3>
                                        </div>
                                </a>
                                </li>
                                <li>
                                    <a [routerLink]="['/browser-plugin']">
                                        <div class="app_name_content">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="assets/images/other_Apps_browser.svg" alt="">
                                            <h3>浏览器插件</h3>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a [routerLink]="['/enterprise']">
                                        <div class="app_name_content" style="padding: 0px;">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="assets/images/Other_Apps_enterprise.svg" alt="">
                                            <h3 style="margin: 0 0 -2px 0;">企业</h3>
                                            <span class="OpenSansFonts" style="font-size: 12px; color: #000; position: relative;">(API, JS & On-Premise)
                                            </span>
                                        </div>
                                    </a>
                                </li>
                                
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="wordPluginPopup" tabindex="-1" role="dialog" aria-labelledby="wordPluginLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-body" style="padding: 0;">
                <button type="button" id="closedPopup" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div id="iframeHolder"></div>

                <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/XBuFdCM3xtk"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                <!-- <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/z-TVcRwVp3A"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe> -->
            </div>
        </div>
    </div>
</div>